export default __webpack_public_path__ + "static/15-rating-5ffb03f502f7af6832908337ef18770b.png";